'use client';

import { useState } from 'react';

type CountryFlagProps = {
  code: string;
  className?: string;
};

/**
 * A real SVG country flag, rather than an emoji or a two-letter country code.
 * FlagCDN serves the ISO 3166-1 SVG files and works for every destination we
 * enable, so adding a country does not require another UI change.
 */
export function CountryFlag({ code, className = '' }: CountryFlagProps) {
  const [failedToLoad, setFailedToLoad] = useState(false);
  const normalizedCode = code.trim().toLowerCase();

  if (!/^[a-z]{2}$/.test(normalizedCode) || failedToLoad) {
    return (
      <span aria-hidden="true" className={`inline-flex h-4 w-6 items-center justify-center rounded-sm bg-slate-200 text-[9px] font-bold text-slate-600 ${className}`}>
        {code.toUpperCase()}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/${normalizedCode}.svg`}
      alt=""
      aria-hidden="true"
      width={24}
      height={16}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailedToLoad(true)}
      className={`inline-block h-4 w-6 shrink-0 rounded-[2px] object-cover shadow-sm ${className}`}
    />
  );
}
